import request from '@/utils/request'


// 获取辅导时间列表
export function teachertimelist(data){
	return request({
    url: '/admin/Webapi/teachertimelist',
		method: 'POST',
    data: data || {}
  })
}
// 辅导详情页
export function coachdetail(data){
	return request({
    url: '/admin/Webapi/coachdetail',
    method: 'POST',
    data: data || {}
  })
}
// 辅导流程接口
export function createpmqdata(data){
	return request({
    url: '/admin/Webapi/createpmqdata',
    method: 'POST',
    data: data || {}
  })
}
// 目标职位
export function getprofession(data){
	return request({
    url: '/admin/Webapi/getprofession',
    method: 'POST',
    data: data || {}
  })
}
// 用户信息
export function coach(data){
	return request({
    url: '/admin/Webapi/coach',
    method: 'POST',
    data: data || {}
  })
}
// 提交目标职位
export function setprofession(data){
	return request({
    url: '/admin/Webapi/setprofession',
    method: 'POST',
    data: data || {}
  })
}
// 导师列表
export function recommend(data){
	return request({
    url: '/admin/Webapi/recommend',
    method: 'POST',
    data: data || {}
  })
}
// 辅导前准备-职位信息
export function coachnotice(data){
  return request({
    url: '/admin/Webapi/coachnotice',
    method: 'POST',
    data: data || {}
  })
}
// 添加咨询师微信
export function wxcoach(data){
  return request({
    url: '/admin/Webapi/wxcoach',
    method: 'POST',
    data: data || {}
  })
}
// 提交选择的时间
export function subteachertime(data){
  return request({
    url: '/admin/Webapi/subteachertime',
    method: 'POST',
    data: data || {}
  })
}
// 导师信息
export function teacherdetail(data){
  return request({
    url: '/admin/Webapi/teacherdetail',
    method: 'POST',
    data: data || {}
  })
}
// 客户评价
export function feebacklist(data){
  return request({
    url: '/admin/Webapi/feebacklist',
    method: 'POST',
    data: data || {}
  })
}
// 个人资料
export function submsg(data){
  return request({
    url: '/admin/Webapi/submsg',
    method: 'POST',
    data: data || {}
  })
}
// 个人资料
export function getreport(data){
  return request({
    url: '/admin/Webapi/getreport',
    method: 'POST',
    data: data || {}
  })
}
// 客户点评
export function feebackteacher(data){
  return request({
    url: '/admin/Webapi/feebackteacher',
    method: 'POST',
    data: data || {}
  })
}
// 导师验证手机号获取数据
export function login(data){
  return request({
    url: 'admin/Tutor/login',
    method: 'POST',
    data: data || {}
  })
}
// 客户点评 提交点评
export function feedback(data){
  return request({
    url: '/admin/Webapi/feedback',
    method: 'POST',
    data: data || {}
  })
}
// 发送验证码
export function sendmsg(data){
  return request({
    url: '/admin/Webapi/sendmsg',
    method: 'POST',
    data: data || {}
  })
}
// 提交验证手机号
export function subcode(data){
  return request({
    url: '/admin/Webapi/subcode',
    method: 'POST',
    data: data || {}
  })
}
